<template>
	<div class="home-intro u-container">
		<div class="home-intro__content">
			<h1>
				<strong>{{ userName }}</strong
				>님<br />
				안녕하세요!
			</h1>

			<div
				class="logo-icon"
				:style="'background: url(' + LogoIcon + ') no-repeat center / contain;'"
			></div>
		</div>
	</div>
</template>

<script>
import LogoIcon from '@/assets/images/home/logo-icon.png';

export default {
	data() {
		return {
			LogoIcon,
		};
	},
	computed: {
		userName() {
			return this.$store.getters['userStore/userName'];
		},
	},
};
</script>

<style scoped>
.home-intro {
	padding: 4rem 0 3rem;
}

.home-intro__content {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 0.75rem;
}

.home-intro__content h1 {
	color: #fff;
	font-size: 1.4375rem;
	font-weight: 300;
	line-height: 1.2;
}

.home-intro__content h1 strong {
	font-weight: 700;
}

.home-intro__content .logo-icon {
	width: 4.0625rem;
	height: 4.0625rem;
}
</style>
